import res from './res'

res.add('ru', {
    title: 'Раздел в разработке',
    description: 'Наши специалисты трудятся, уже скоро все заработает'
})
